// MyPage.tsx

import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid"; // ← Grid v2（正式版）
import { Lock, Notifications, Computer, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomMenu from "../../components/CustomMenu/CustomMenu";

/**
 * マイページコンポーネント
 * - パスワード変更・通知設定などへのナビゲーションカードを表示する
 * - レスポンシブ対応（スマートフォン・タブレット・PC）
 */
export default function MyPage() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  // レスポンシブ：カードの高さとアイコンサイズを少し調整
  const cardMinHeight = isXs ? 180 : isSm ? 200 : 220;
  const iconFontSize = isXs ? 36 : 40;

  return (
    <CustomMenu>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Typography variant="h4" gutterBottom>
          マイページ
        </Typography>

        {/* PC(md以上)では2列、md未満（スマホ・多くのタブレット）では1列 */}
        <Grid container spacing={3} sx={{ width: "100%" }}>
          {/* プロフィール */}
          {/* 実データに置き換え可：ログインユーザー名・メール */}
          {/* 未実装のためコメントアウト */}
          {/* <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <Card
              sx={{
                minHeight: cardMinHeight,
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              elevation={2}
            >
              <CardHeader title="プロフィール" sx={{ pb: 0 }} />
              <CardContent sx={{ flexGrow: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Avatar sx={{ width: 64, height: 64 }} />
                  <Box>
                    <Typography variant="h6">ユーザー名</Typography>
                    <Typography variant="body2" color="text.secondary">
                      user@example.com
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
              <Divider />
              <CardActions sx={{ p: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<Edit />}
                  onClick={() => navigate("/ProfileEdit")}
                >
                  編集
                </Button>
              </CardActions>
            </Card>
          </Grid> */}

          {/* セキュリティ（パスワード変更） */}
          <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <Card
              sx={{
                minHeight: cardMinHeight,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                width: "100%",
              }}
              elevation={2}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Lock
                  sx={{ fontSize: iconFontSize, color: "primary.main", mb: 1 }}
                />
                <Typography variant="h6" gutterBottom>
                  セキュリティ
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  パスワードや認証設定を管理します
                </Typography>
              </CardContent>
              <Divider />
              <CardActions sx={{ p: 2, justifyContent: "center" }}>
                <Button
                  variant="contained"
                  onClick={() => navigate("/ChangePasswordForm")}
                >
                  パスワードを変更する
                </Button>
              </CardActions>
            </Card>
          </Grid>

          {/* 通知設定 */}
          {/* 未実装のためコメントアウト */}
          {/* <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <Card
              sx={{
                minHeight: cardMinHeight,
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              elevation={2}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Notifications
                  sx={{ fontSize: iconFontSize, color: "primary.main", mb: 1 }}
                />
                <Typography variant="h6" gutterBottom>
                  通知設定
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  メール通知やアラートの受信設定を変更します
                </Typography>
              </CardContent>
              <Divider />
              <CardActions sx={{ p: 2, justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/NotificationSettings")}
                >
                  編集
                </Button>
              </CardActions>
            </Card>
          </Grid> */}

          {/* ログイン履歴 */}
          {/* <Grid size={{ xs: 12, md: 6 }} sx={{ display: "flex" }}>
            <Card
              sx={{
                minHeight: cardMinHeight,
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              elevation={2}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Computer
                  sx={{ fontSize: iconFontSize, color: "primary.main", mb: 1 }}
                />
                <Typography variant="h6" gutterBottom>
                  ログイン履歴
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  最終ログイン：2025/04/24 12:34
                </Typography>
              </CardContent>
              <Divider />
              <CardActions sx={{ p: 2, justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/LoginActivity")}
                >
                  詳細を見る
                </Button>
              </CardActions>
            </Card>
          </Grid> */}
        </Grid>
      </Container>
    </CustomMenu>
  );
}
